import { cs } from "@repo/ui";
import { Seo } from "../../../components/SEO";
import { BodyTextM } from "../../../components/Typography";
import withProtection from "../../../highOrderComponents/withProtection";

export const Title = (): JSX.Element => {
	return <>{cs.profile.personalInformation.header}</>;
}

const Info = (): JSX.Element => {
	return (
		<BodyTextM dangerouslySetInnerHTML={{ __html: cs.profile.personalInformation.content }} />
	);
};

export const Head = (): JSX.Element => (
	<Seo title="Informace">
		<meta name="robots" content="noindex" />
	</Seo>
);

export default withProtection(Info);
